import React, { useEffect, useState } from 'react';
import { ComponentDefiDefiWinners } from 'graphql/generated/graphql';
import { Avatar } from 'components/atoms/Avatar';
import { mediaDir } from 'appolloConfig';
import useStyle from './winnersList.style';
import { getAvatarUrlFromPedagogicalChallengeQuery } from 'helpers/transformApiResponse/avatar';

interface WinnersListProps {
  list: ComponentDefiDefiWinners[];
}

export const WinnersList = ({ list }: WinnersListProps) => {
  const classes = useStyle();
  const [numberOfWinners, setNumberOfWinners] = useState(0);

  useEffect(() => {
    let counter = 0;
    if (list.length > 0) {
      list.forEach(
        recompense => (counter += recompense.recompenses_winners.data.length)
      );
    }
    setNumberOfWinners(counter);
  }, [list]);

  return (
    <>
      {numberOfWinners > 0 ? (
        <>
          <h4 className={classes.title}>Liste des gagnants</h4>
          {list.map((recompense, index) => (
            <div className={classes.root} key={index}>
              <p>{recompense.category}</p>
              {recompense.recompenses_winners.data.length > 0 &&
                recompense.recompenses_winners.data.map((user, subIndex) => (
                  <div className={classes.winner} key={subIndex}>
                    <div>
                      <Avatar
                        alt={user.attributes.username}
                        source={
                          getAvatarUrlFromPedagogicalChallengeQuery(user) &&
                          mediaDir +
                            getAvatarUrlFromPedagogicalChallengeQuery(user)
                        }
                        variant="small"
                      />
                    </div>
                    <div className={classes.name}>
                      <p>{user.attributes.username}</p>
                      <p className={classes.lyceeName}>
                        {
                          user.attributes.classes.data[0].attributes.lycee?.data
                            ?.attributes?.name
                        }
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          ))}
        </>
      ) : (
        <p>Les résultats ne sont pas encore annoncés !</p>
      )}
    </>
  );
};
